import React from "react";

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-gray-800 to-gray-900 text-white py-8">
      <div className="container mx-auto px-6">
        <div className="flex flex-col items-center">
          <p className="text-lg mb-4">© 2024 WebMinds. Tous droits réservés.</p>
          <div className="flex space-x-6 mb-6">
            <a
              href="https://www.linkedin.com/in/owen-dayes-31ba01223/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-blue-400 transition-colors"
              aria-label="LinkedIn"
            >
              <i className="fab fa-linkedin-in fa-2x"></i>
            </a>
            <a
              href="https://www.instagram.com/web.mindsdev/"
              target="_blank"
              rel="noopener noreferrer"
              className="text-white hover:text-pink-400 transition-colors"
              aria-label="Instagram"
            >
              <i className="fab fa-instagram fa-2x"></i>
            </a>
          </div>
          <p className="text-sm">
            <a
              href="/mentions-legales"
              className="hover:text-blue-400 transition-colors"
            >
              Mentions légales
            </a>{" "}
            |
            <a
              href="/conditions-generales"
              className="hover:text-blue-400 transition-colors"
            >
              {" "}
              Conditions d'utilisation
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
